//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 27.09.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngDate', srsngDate)
        .directive('srsngTime', srsngTime)
        .directive('srsngDateTime', srsngDateTime);

    function srsngDate() {

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {

                ngModel.$parsers.push(date => {
                    return moment.utc(date, 'YYYY MM DD').format();
                });

                ngModel.$formatters.push(date => {
                    return moment.utc(date).format('YYYY/MM/DD');
                });
            }
        };
    }

    function srsngTime() {

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {

                ngModel.$parsers.push(time => {
                    return moment.utc(time, 'h:mm A').format();
                });

                ngModel.$formatters.push(time => {
                    return moment.utc(time).format('h:mm A');
                });
            }
        };
    }

    function srsngDateTime() {

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {

                ngModel.$parsers.push(dateTime => {
                    return moment.utc(dateTime, 'YYYY MM DD hh:mm A').format();
                });

                ngModel.$formatters.push(dateTime => {
                    return moment.utc(dateTime).format('YYYY/MM/DD hh:mm A');
                });
            }
        };
    }
})();